<template>
  <modal
    width="540px"
    speed="fast"
    class="report-modal"
    maskNoClick
    noOutClose
    noFooter
    enter-active-class="fadeIn"
    leave-active-class="fadeOut"
    :show.sync="show"
    @update:show="cancelUnusualCommit"
  >
    <div slot="header">
      问题上报
    </div>
    <div slot="content">
      <el-form ref="form" :model="unusualForm" class="unusual-form">
        <el-form-item label="问题类别：" required>
          <el-select v-model="unusualForm.type">
            <el-option label="网络问题" :value="1"></el-option>
            <el-option label="系统问题" :value="2"></el-option>
            <el-option label="设备问题" :value="3"></el-option>
            <el-option label="题目问题" :value="4"></el-option>
            <el-option label="其他问题" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题说明：" required>
            <textarea
              class="unusual-textarea"
              maxlength="500"
              placeholder="请详细描述当下遇到的异常情况， 500字内。（必填，异常描述如：第21题图片看不清）"
              v-model="unusualForm.description" ></textarea>
        </el-form-item>
      </el-form>
      <div class="tip">
        <span class="title">温馨提示：</span>
        <span class="text">考生进行问题报备后，<strong>请继续进行下一道题的作答，完成考试。考试结束后将有工作人员跟进人工核验。</strong></span>
      </div>
      <div class="tip">
        <span class="title">常见问题：</span>
        <a href="https://shimo.im/docs/cpcycjX3XJR6tQDC" target="_blank">-> 双摄像头切换指引</a>
      </div>
      <div class="btn-wrap">
        <button
          class="cancel"
          @click="cancelUnusualCommit">取消</button>
        <button
          class="continue"
          :style="`background: ${$store.state.theme.buttonBackground} box-shadow: ${$store.state.theme.buttonShadow}`"
          @click="commitUnusual">确定</button>
      </div>
    </div>
  </modal>
</template>

<script>
// import { post } from '@/utils/ajax'
import { Form, FormItem, Select, Option } from 'element-ui'
import Modal from '@/components/Modal'

export default {
  components: {
    ElForm: Form,
    ElFormItem: FormItem,
    ElSelect: Select,
    ElOption: Option,
    Modal
  },
  data() {
    return {
      show: true,
      unusualForm: {
        type: 1,
        description: ''
      }
    }
  },
  methods: {
    // 取消上报异常
    cancelUnusualCommit () {
      this.unusualForm = {
        type: 1,
        description: ''
      }
      this.$emit('cancelUnusualCommit')
    },
    // 上报异常
    async commitUnusual () {
      const { description } = this.unusualForm
      if (description === '') {
        this.$message.error('请填写异常说明！')
        return
      }
      this.$emit('commitUnusual', this.unusualForm)
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/.modal-head {
    padding: 16px 20px;
    border-bottom: 1px solid #F1F1F1;
  }
  .unusual-form {
    .unusual-textarea {
      border: 1px solid #DCDFE6;
      resize: none;
      width: 100%;
      height: 150px;
      font-size: 14px;
      padding: 10px;
      color: #606266;
      border-radius: 4px;
      &::placeholder {
        color: #999;
      }
    }
    /deep/ .el-form-item {
      display: flex;
      .el-form-item__content {
        flex: 1;
        .el-input__inner {
          width: 100% !important;
        }
      }
      .el-select {
        width: 100%;
      }
    }
  }
</style>
